export const TRANSLATION_STORAGE_KEY = 'translation_key';
